import { render, staticRenderFns } from "./CreditsOutstandingDetails.vue?vue&type=template&id=7c3b07ab"
import script from "./CreditsOutstandingDetails.vue?vue&type=script&lang=js"
export * from "./CreditsOutstandingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports